$(document.body).on('click', '.gdpr-cookies-settings-btn', function (e) {
  e.stopPropagation();
  e.preventDefault();

  if (typeof window.toggleReactModal === 'function') {
    toggleReactModal({ isCookiesModalOpen: true });
  }
});
